import AbstractShape, {Dimensions, DimensionProperties} from "./AbstractShape";
import Length from "../../../../source/js/shared/models/Geometry/Length";
import DimensionLine from "@/Models/Lines/DimensionLine";

export class Egg extends AbstractShape {
	constructor( dimensions?: object ) {
		super( 'egg', dimensions );
	}

	getHeight(): Length {
		return this.cleanedPrimitives.height;
	}

	getLength(): Length {
		return this.cleanedPrimitives.height;
	}

	getWidth(): Length {
		return this.cleanedPrimitives.width;
	}

	getDimensionProperties(): DimensionProperties {
		return { primary: 'height', secondary: 'width' };
	}

	getDimensionLines(ratio = 1, focusedElement = '', forceRender = false): DimensionLine[] {
		if(focusedElement.includes("cutout_measurement") || forceRender) {
			const radiusY = this.getHeight().divide(3);
			const radiusX = this.getWidth().divide(2);

			return [
				new DimensionLine(
					[-radiusX.in_mm(), -radiusY.in_mm()],
					[-radiusX.in_mm(), this.getHeight().in_mm()-radiusY.in_mm()],
					this.renderDimensionLabel('height'),
					[-40, 0],
					ratio,
					this.getDimensionLineType('measurements-egg-height', focusedElement, forceRender)
				),
				new DimensionLine(
					[-radiusX.in_mm(), -radiusY.in_mm()],
					[this.getWidth().in_mm()-radiusX.in_mm(), -radiusY.in_mm()],
					this.renderDimensionLabel('width'),
					[0, -40],
					ratio,
					this.getDimensionLineType('measurements-egg-width', focusedElement, forceRender)
				),
			];
		}

		return [];
	}

	getDefaultDimensions(): Dimensions {
		return {
			height: 50,
			width: 30,
		};
	}

	getDefaultCutoutDimensions(parentShape: AbstractShape): Dimensions {
		const enclosingRectangle = parentShape.getEnclosingRectangle();
		const width = enclosingRectangle.width();
		const height = enclosingRectangle.height();

		return {
			width: width.divide(3).in_cm(),
			height: height.divide(2).in_cm(),
		};
	}
}
